module.exports = __webpack_public_path__ + "static/media/main-hatching-failed.121af0e0.png";